import React, { useEffect, useState } from 'react';
import { api } from '../lib/api';
import { fmtDateTime } from '../lib/date';
import { Card, CardHeader, CardTitle, CardContent } from '../components/ui/card';
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '../components/ui/table';
import { Badge } from '../components/ui/badge';
import { Input } from '../components/ui/input';
import { Search } from 'lucide-react';

const ACTION_LABEL = {
  'create_employee': 'Mitarbeiter angelegt',
  'update_employee': 'Mitarbeiter aktualisiert',
  'deactivate_employee': 'Mitarbeiter deaktiviert',
  'create_project': 'Projekt angelegt',
  'update_project': 'Projekt aktualisiert',
  'extend_project': 'Projekt verlängert',
  'archive_project': 'Projekt archiviert',
  'create_cost_center': 'Kostenstelle angelegt',
  'update_cost_center': 'Kostenstelle aktualisiert',
  'delete_cost_center': 'Kostenstelle gelöscht',
  'sort_cost_centers': 'Kostenstellen sortiert',
  'create_assignment': 'Einsatz angelegt',
  'update_assignment': 'Einsatz aktualisiert',
  'delete_assignment': 'Einsatz entfernt',
  'bulk_move_assignments': 'Einsätze verschoben',
  'lend_to_schabos': 'Schabos-Verleih',
  'lend_to_other_kst': 'KSt-Ausleihe',
  'create_absence': 'Abwesenheit eingetragen',
  'create_absence_range': 'Abwesenheitszeitraum',
  'delete_absence': 'Abwesenheit gelöscht',
  'create_school_pattern': 'Schulmuster erstellt',
  'delete_school_pattern': 'Schulmuster gelöscht',
  'create_holiday': 'Feiertag manuell',
  'toggle_holiday': 'Feiertag geschaltet',
  'delete_holiday': 'Feiertag gelöscht',
  'upsert_day_note': 'Notiz',
  'create_user': 'Benutzer angelegt',
  'update_user': 'Benutzer aktualisiert',
  'delete_user': 'Benutzer gelöscht',
  'reset_password': 'Passwort zurückgesetzt',
  'change_password': 'Passwort geändert',
  'export_backup': 'Backup exportiert',
  'import_backup': 'Backup importiert',
  'reset_demo': 'Demo-Daten zurückgesetzt',
};

export default function ActivityLogPage() {
  const [items, setItems] = useState([]);
  const [filter, setFilter] = useState('');

  useEffect(() => {
    api.get('/activity-log', { params: { limit: 500 } }).then(r => setItems(r.data));
  }, []);

  const filtered = items.filter(i => {
    if (!filter) return true;
    const q = filter.toLowerCase();
    return (
      (i.user_name || '').toLowerCase().includes(q) ||
      (i.summary || '').toLowerCase().includes(q) ||
      (ACTION_LABEL[i.action] || i.action).toLowerCase().includes(q) ||
      (i.entity_type || '').toLowerCase().includes(q)
    );
  });

  return (
    <div className="p-4 md:p-6 space-y-4">
      <Card>
        <CardHeader className="flex flex-row items-center justify-between gap-4 pb-3">
          <CardTitle className="font-display text-lg">Aktivitätsprotokoll</CardTitle>
          <div className="relative w-64">
            <Search size={14} className="absolute left-2 top-1/2 -translate-y-1/2 text-slate-400"/>
            <Input placeholder="Filter…" value={filter} onChange={e => setFilter(e.target.value)} className="pl-7 h-8" data-testid="activity-search"/>
          </div>
        </CardHeader>
        <CardContent>
          <Table>
            <TableHeader><TableRow>
              <TableHead>Zeitpunkt</TableHead><TableHead>Benutzer</TableHead><TableHead>Aktion</TableHead><TableHead>Entität</TableHead><TableHead>Details</TableHead>
            </TableRow></TableHeader>
            <TableBody>
              {filtered.map(i => (
                <TableRow key={i.id}>
                  <TableCell className="font-mono text-xs">{fmtDateTime(i.timestamp)}</TableCell>
                  <TableCell className="text-sm">{i.user_name || '-'}</TableCell>
                  <TableCell><Badge variant="outline">{ACTION_LABEL[i.action] || i.action}</Badge></TableCell>
                  <TableCell className="text-xs text-slate-600">{i.entity_type}</TableCell>
                  <TableCell className="text-sm">{i.summary || '-'}</TableCell>
                </TableRow>
              ))}
              {filtered.length === 0 && <TableRow><TableCell colSpan={5} className="text-center text-slate-500">Keine Einträge.</TableCell></TableRow>}
            </TableBody>
          </Table>
        </CardContent>
      </Card>
    </div>
  );
}
